import { getData, postData, putData, extractFile } from './index';
import { QUATERLY_REPORT_ERROR, 
  FETCH_QUATERLY_REPORT, 
  FETCH_QUATERLY_REPORT_LIST, 
  CREATE_QUATERLY_REPORT, 
  UPDATE_PROJECT, 
  UPDATE_QUATERLY_PICTURE,
  EXPORT_QUATERLY_REPORT,
LOADING } from './types';


//= ===============================
// quaterlyReport actions
//= ===============================

export function createQuaterlyReport() {
  var editor = JSON.parse(localStorage.getItem("user"));
    const data = {};
    data.project = {
      id : this.props.project._id
    }
    data.consultantEditor = {
      firstName : editor.firstName,
      LastName : editor.lastName,
      _id : editor._id
    }
    const url = '/quaterlyReport';
    return dispatch => {
      postData(CREATE_QUATERLY_REPORT, QUATERLY_REPORT_ERROR, true, url, dispatch, data)
    }
    
    
    
}

export function fetchQuaterlyReport(documentId) {
  return async (dispatch) => {
    const url = '/quaterlyReport/'+documentId;
    await dispatch({
      type: LOADING,
    });
    getData(FETCH_QUATERLY_REPORT, QUATERLY_REPORT_ERROR, true, url, dispatch);
  }
}

export function getAutocompleteList(documentId) {
  let data = {documentId:documentId};
  const url = '/quaterlyReport/autocompleteList'
  return dispatch => postData(FETCH_QUATERLY_REPORT_LIST, QUATERLY_REPORT_ERROR, true, url, dispatch,data);
}

export function validate(documentId) {
  const url = '/quaterlyReport/validate/'+documentId;
  let data = {};
  return dispatch => putData(UPDATE_PROJECT, QUATERLY_REPORT_ERROR, true, url, dispatch, data);
}

export function updateQuaterlyReport(document,id) {
  const data = { document };
  const url = '/quaterlyReport/updatedocument/'+ id
  return dispatch => putData(UPDATE_PROJECT, QUATERLY_REPORT_ERROR, true, url, dispatch, data);
}

export function uploadPicture(file, documentId) {
  let data = new FormData()
  data.append('file', file)
  const url = '/quaterlyReport/picture/'+documentId;
  return dispatch => putData(UPDATE_QUATERLY_PICTURE, QUATERLY_REPORT_ERROR, true, url, dispatch, data);
}

export function extractQuaterlyReport(documentId,languageId) {
  return async (dispatch) => {
    const url = `/quaterlyReport/extract/${documentId}?languageId=${languageId}`;
    await dispatch({
      type: LOADING,
    });
    extractFile(EXPORT_QUATERLY_REPORT, QUATERLY_REPORT_ERROR, true, url, dispatch);
  }
}
